import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { variableGlobal } from '../global.enum';
import { DetalleItemComponent } from '../intranet/crm/stock-comercial/detalleItem';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DetalleItemService {

  constructor(
    private modalService: NgbModal,
    private _http: HttpClient,
  ) { }

  abrirDetalleItem(item:any){

    let ngbModalOptions: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false,
      size:"xl",
      modalDialogClass:variableGlobal.CLASS_MODAL_BG
    };


    
    const modalRef = this.modalService.open(DetalleItemComponent, ngbModalOptions);
    modalRef.componentInstance.Item = item;

    modalRef.result.then((data) => {

    }, (reason) => {

    });
  }

  async obtieneListaMaterialVirtual(items) {
    const body =
    {
      "TOKEN": "INDESAD",
      "resultado":items
    }

    

    return this._http.post(environment.RUTA_API + '/api/SAP/obtieneListaMaterialVirtual', body).toPromise();
  }

}
